import { FC, HTMLAttributes, MouseEvent, lazy, memo, Suspense } from 'react';
import { useInView } from 'react-intersection-observer';
import cn from 'classnames';

import { MapData } from '@Types/Map';
import { SellPointData } from '@Types/SellPoints';
import styles from './ShowroomsMap.module.css';

export interface ShowroomsMapProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  map?: MapData;
  defaultSellPoints?: SellPointData[];
  selectedPoint?: SellPointData;
  onGoFull?: (e: MouseEvent, selectedPoint: SellPointData) => void;
}

const MapWithPopup = lazy(() => import('./elems/MapWithPopup'));

const MapPlaceholder: FC = () => {
  return <div className={styles.mapPlaceholder} />;
};

const ShowroomsMap: FC<ShowroomsMapProps> = (props) => {
  const { className, map, defaultSellPoints, selectedPoint, onGoFull, ...restProps } = props;
  const [ref, inView] = useInView({
    rootMargin: '100px 0px',
    triggerOnce: true,
  });

  return (
    <div {...restProps} className={cn(styles.section, className)} ref={ref}>
      {map?.title && <div className={styles.title}>{map.title}</div>}
      {map?.description && <div className={styles.text}>{map.description}</div>}

      {inView ? (
        <Suspense fallback={<MapPlaceholder />}>
          <MapWithPopup
            className={styles.mapWithPopup}
            key={map.regionId}
            map={map}
            defaultSellPoints={defaultSellPoints}
            defaultSelectedPoint={selectedPoint}
            onGoFull={onGoFull}
          />
        </Suspense>
      ) : (
        <MapPlaceholder />
      )}
    </div>
  );
};

export default memo(ShowroomsMap);
